/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";

interface ItemVenda {
  qtds: number;
  descricao: string;
  referencia: string;
  un: string;
  preco: number;
  total: number;
}

interface RomaneioVenda {
  idmov: string;
  emissao: string;
  numero: string | null;
  nome: string;
  cpf: string;
  descricao: string;
  vprod: number;
  desconto: number;
  acrescimo: number;
  total: number;
}

interface Venda {
  romaneios: RomaneioVenda;
  itens: ItemVenda[];
}

async function RelatorioVendasDetalhado(dados: Venda[], periodo: string) {

  const totalGeral = dados.reduce(
    (acc, item) => acc + (item?.romaneios?.total ?? 0),
    0
  );

  const linhas: any[] = [];

  dados.forEach((venda) => {

    const r = venda.romaneios;
    if (!r) return;

    // =========================
    // CABEÇALHO DA VENDA
    // =========================

    linhas.push([
      {
        text: `Cliente: ${r.nome}\nCPF/CNPJ: ${r.cpf}`,
        colSpan: 3,
        fontSize: 7,
        border: [true, false, false, false]
      },
      {}, {},
      {
        text: `Descrição: ${r.descricao}`,
        fontSize: 7,
        border: [false, false, false, false]
      },
      {
        text: `Valor.Prod: ${formatMoney(r.vprod)}`,
        alignment: "right",
        fontSize: 7,
        border: [false, false, false, false]
      },
      {
        text: `Desc: ${formatMoney(r.desconto)}`,
        alignment: "right",
        fontSize: 7,
        border: [false, false, false, false]
      },
      {
        text: `Acrés: ${formatMoney(r.acrescimo)}`,
        alignment: "right",
        fontSize: 7,
        border: [false, false, false, false]
      },
      {
        text: `Total: ${formatMoney(r.total)}`,
        alignment: "right",
        bold: true,
        fontSize: 7,
        border: [false, false, true, false]
      }
    ]);
    // =========================
    // CABEÇALHO DOS ITENS
    // =========================

    linhas.push([
      { text: "Produto", bold: true, colSpan: 2, fillColor: "#f3f4f6", fontSize: 7, border: [true, false, false, false] },
      {},
      { text: "Referência", bold: true, fillColor: "#f3f4f6", fontSize: 7 },
      { text: "Qtd", bold: true, alignment: "right", fillColor: "#f3f4f6", fontSize: 7 },
      { text: "UN", bold: true, alignment: "center", fillColor: "#f3f4f6", fontSize: 7 },
      { text: "Valor Unit.", bold: true, alignment: "right", fillColor: "#f3f4f6", fontSize: 7 },
      { text: "Total", bold: true, alignment: "right", fillColor: "#f3f4f6", fontSize: 7 },
      { text: "", fillColor: "#f3f4f6", border: [false, false, true, false] }
    ]);

    // =========================
    // ITENS
    // =========================

    venda.itens.forEach((item) => {

      linhas.push([
        { text: item.descricao, colSpan: 2, fontSize: 7, border: [true, false, false, false] },
        {},
        { text: item.referencia, fontSize: 7 },
        { text: formatQtd(item.qtds), alignment: "right", fontSize: 7 },
        { text: item.un, alignment: "center", fontSize: 7 },
        { text: formatMoney(item.preco), alignment: "right", fontSize: 7 },
        { text: formatMoney(item.total), alignment: "right", fontSize: 7 },
        { text: "", border: [false, false, true, false] }
      ]);

    });

    // =========================
    // SEPARADOR ENTRE VENDAS
    // =========================

    linhas.push([
      {
        text: "",
        colSpan: 8,
        border: [true, false, true, true],
      },
      "", "", "", "", "", "", ""
    ]);

  });

  const documentDefinition: any = {

    pageSize: "A4",
    pageOrientation: "portrait",
    pageMargins: [25, 25, 25, 25],

    content: [

      {
        text: process.env.REACT_APP_URL_EMPRESA,
        fontSize: 14,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 4]
      },

      {
        text: "RELATÓRIO DE VENDAS DETALHADO",
        fontSize: 12,
        bold: true,
        alignment: "center"
      },

      {
        text: periodo,
        alignment: "center",
        fontSize: 8,
        margin: [0, 0, 0, 10]
      },

      {
        table: {
          headerRows: 0,
          widths: [120, 0, "*", 50, 40, 60, 60, 60],
          body: linhas
        },

        layout: {
          hLineColor: () => "#9ca3af",
          vLineWidth: () => 0
        }
      },

      {
        text: "TOTAL GERAL: " + formatMoney(totalGeral),
        alignment: "right",
        bold: true,
        fontSize: 10,
        margin: [0, 15, 0, 0]
      }

    ]

  };

  pdfMake.createPdf(documentDefinition).open();
}

function formatMoney(value: number) {
  const v = Number(value ?? 0);
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(v.toFixed(2)));
}

function formatQtd(value: number) {
  const v = Number(value ?? 0);
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(v.toFixed(2)));
}

export default RelatorioVendasDetalhado;